import { useTheme } from '@mui/material/styles';
import { useCurrentBreakpoint } from './useCurrentBreakpoint';

export const useGetSpacing = () => {
  const theme = useTheme();
  const { breakpoint: currentBreakpoint } = useCurrentBreakpoint(); // Get current breakpoint

  const getSpacing = (spacingName: keyof typeof theme.customSpacing) => {
    // Fetch the spacing for the current breakpoint from the theme
    const spacingMap = theme.customSpacing[spacingName] as Record<
      string,
      number
    >;

    // Return the spacing for the current active breakpoint (e.g., 'sm', 'md', 'lg', etc.)
    return spacingMap[currentBreakpoint] || 0; // Fallback to 0 if no value is found
  };

  return getSpacing;
};
